import React from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import FileItem from './FileItem';
import { Schema } from '../../../../../amplify/data/resource';

const selectionSet = [
  'id',
  'viewed',
  'createdAt',
  'path',
  'date',
  'status',
  'error',
  'type',
  'processed',
  'xmlVersion',
  'executionDate',
  'workEnvironment',
  'fileNumber',
  'sequenceNumber',
  'senderCode',
  'senderIdentifierType',
  'senderId',
  'senderName',
  'senderContactFirstName',
  'senderContactLastName',
  'senderContactPhone',
  'senderContactEmail',
  'senderContactCellular',
  'recipientCode',
  'recipientIdentifierType',
  'recipientId',
  'recipientCreatorIdentifier',
  'userId',
  'user.*',
  'deposits.totalDepositAmount',
  'deposits.employees.employeeId',
] as const;

// @ts-ignore
type File = SelectionSet<Schema['File']['type'], typeof selectionSet>;

interface FileListProps {
  files: File[];
}

const FileList: React.FC<FileListProps> = ({ files }) => {
  const sortedFiles = [...files].sort((a, b) => {
    const dateA = new Date(a.createdAt);
    const dateB = new Date(b.createdAt);
    return dateB.getTime() - dateA.getTime();
  });

  return (
    <Box sx={{ direction: 'rtl', width: '100%' }}>
      <TableContainer
        component={Paper}
        sx={{
          backgroundColor: 'transparent',
          boxShadow: 'none',
          overflowY: 'auto',
          width: '100%',
        }}
      >
        <Table
          stickyHeader
          sx={{
            backgroundColor: 'transparent',
            borderCollapse: 'separate',
            borderSpacing: '0 10px',
            width: '100%',
            tableLayout: 'fixed',
          }}
        >
          <TableHead>
            <TableRow sx={{ backgroundColor: '#E7ECF1' }}>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: '#E7ECF1',
                  width: '8%',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  תאריך שליחת נתונים
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: '#E7ECF1',
                  width: '10%',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  חודש שכר
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: '#E7ECF1',
                  width: '15%',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  פרטי מעסיק
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: '#E7ECF1',
                  width: '8%',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  תאריך ערך
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: '#E7ECF1',
                  width: '12%',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  סך הפקדה
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: '#E7ECF1',
                  width: '12%',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  נקלט בהצלחה
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: '#E7ECF1',
                  width: '12%',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  בתהליך קליטה
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: '#E7ECF1',
                  width: '10%',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  שגויים
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: '#E7ECF1',
                  width: '8%',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  אחוז קליטה
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: '#E7ECF1',
                  width: '15%',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  התקבל במסלקה
                </Typography>
              </TableCell>

            </TableRow>
          </TableHead>
          <TableBody>
            {sortedFiles.map((file: File, index: number) => (
               <FileItem key={index} file={file} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default FileList;
